import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GeneralSettings, Tool } from 'app/profile/models/generic.model';
import { AuthData } from '@tesla/ng-auth';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { Store } from '@ngrx/store';
import { GetSupplierProfileCurrentUser } from 'app/profile/store/app.actions';


@Component({
    selector: 'app-override-comment-dialog',
    templateUrl: './override-comment-dialog.component.html',
    styleUrls: ['./override-comment-dialog.component.scss']
})
export class OverrideCommentDialog implements OnInit {
    settings: GeneralSettings;
    showCMTChanges: any;
    deliverableForm: FormGroup;

    get overrideComment() { return this.deliverableForm.get('overrideComment'); }
    get message(){
        return "There is a mismatch between the selected tool status and the demand of the parts added, please review the description for the Tool status to select the appropriate option. Otherwise, please add a comment to justify the selected option.";
    }

    constructor(private fb: FormBuilder,
        private authData: AuthData,
        private supplierStore: Store<SupplierState>,
        public dialogRef: MatDialogRef<OverrideCommentDialog>,
        @Inject(MAT_DIALOG_DATA) public data:
            {
                toolData: Tool,
                status: string,
            }) {

            this.deliverableForm = this.fb.group({
            overrideComment: [''],
        });
    }



    onSave(){
        this.data.toolData.data.statusMismatchOverrideComment = this.deliverableForm.value.overrideComment;
        this.dialogRef.close({ toolData: this.data.toolData });
    }

    ngOnInit() {
        const userInfo = this.authData.getUserInfo();
        this.supplierStore.dispatch(new GetSupplierProfileCurrentUser());
    }

    onClose(): void {
        this.dialogRef.close();
    }
}
